import React from 'react';
import { Link } from 'gatsby';
import styles from './Speaker.module.scss';
import cnames from 'classnames';
import GoChevronRight from 'react-icons/lib/go/chevron-right';

const Speaker = ({name, profileImage, country, path, className}) => {
  return (
    <Link className={cnames(styles.speaker, className)} to={path}>
      <img className={styles.image} src={profileImage} alt="" />
      <div className={styles.info}>
        <div className={styles.name}>
          {name}
        </div>
        {<div className={styles.country}>
          {country}
        </div>}
        <div className={styles.moreInfo}>
          MORE INFO <GoChevronRight />
        </div>
      </div>
    </Link>
  );
};

export default Speaker;